module.exports = __webpack_public_path__ + "assets/img/Culture_002.acdcc7ac-ps.jpg";